module.exports = __webpack_public_path__ + "img/jet_black.f6fa0f71.png";